<template>
    <div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择宠物类型',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="param.type"
                :list="typelist"
                @finish="(val)=> {
                    param.type=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择搜索时间类型',width:'170px',clearable:true,filterable:true,ischange:true}"
                :value="param.timetype"
                :list="timetypelist"
                @finish="(val)=> {
                    param.timetype=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime 
                :option="{clearable:true,width:'300px',ischange:true}"
                :value="param.time"
                @finish="(val)=> {
                    param.time=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcinput :option="{placeholder:'请输入宠物名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                :value="param.key"
                @finish="(val)=> {
                    if(val.type=='input') {param.key=val.value;param.ischange=true;}
                    if(val.type=='change') {param.key=val.value;param.ischange=true;}
                    if(val.type=='keydown') GetBirthInfos();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetBirthInfos()" />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'添加繁育'}" @finish="AddBirth()" />
        </el-form-item>

    </el-form>
    </div>

    <div class="TTL-table top20" id="table-birth-obj">
        <el-table :data="list" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="序号" type="index" min-width="50" align="center" />
            <el-table-column label="繁育宠物" prop="typename" align="left" v-if="pagelabel.typename">
                <template #default="scope">
                    <span class="brthname">{{'【'+scope.row.boy_pet_name+'】'+scope.row.boy_pet_name+' x '+scope.row.girl_pet_name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属商户" prop="shopname" align="center" v-if="pagelabel.shopname" />
            <el-table-column label="交配时间" prop="loveday" align="center" v-if="pagelabel.loveday" />
            <el-table-column label="预产期" align="center">
                <template #default="scope">
                    <div class="TTL-birth-btd" style="display:inline-block;width:100%;text-align:center">
                        {{scope.row.expireday}}
                        <span style="display:inline-block;width:100%;text-align:center">（剩余<i>{{scope.row.birthday}}</i>天）</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="生产提醒时间" prop="expire_remind_day" align="center" v-if="pagelabel.expire_remind_day">
                <template #default="scope">
                    <div>{{scope.row.expire_remind_day ? scope.row.expire_remind_day : '/'}}</div>
                    <div class="TTL-birth-btd" style="display:inline-block;width:100%;text-align:center;" v-if="scope.row.push_error_msg">
                    <div class="TTL-info-status-image">
                        <el-tooltip :content="'推送失败：'+scope.row.push_error_msg" placement="top">
                        <el-image :src="scope.row.finish_status==0 ? require('@/assets/icon/msg-notice.png') : require('@/assets/icon/wrong.png') " />
                        </el-tooltip>
                    </div>
                    </div>
                </template>
            </el-table-column>
            <!--
            <el-table-column label="操作" align="center" fixed="right" min-width="180">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditBirth(scope.row.id)" v-if="scope.row.status==0" />
                    <wcbutton :option="{title:'确认生产',type:'del'}" @finish="FinishBirth(scope.row.id)" v-if="scope.row.status==0" class="left10"/>
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelBirth(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
            -->
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetBirthInfos();
                    }"
                />
            </div>
        </div>
    </div>

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'Birth'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />

</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import INTERFACE_MODEL_BIRTH from '@/Interface/Pets/Birth';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
export default {
    components:{
        Pagelabel
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            param: {
                type:'',
                timetype:'',
                time:'',
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0
            },
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除繁育'},
                {id:2,name:'批量修改繁育'},
            ],
            typelist:[],
            timetypelist:[
                {id:1,name:'按交配日期搜索'},
                {id:2,name:'按生产日期搜索'},
                {id:3,name:'按提醒日期搜索'},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.Getpagelabel();      //获取页面显示标签信息
            this.GetPetTypelist();    //获取宠物类型
            this.GetBirthInfos();     //获取繁育信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {              //组件已存在，同级兄弟元素调用时产生的操作
                this.GetBirthInfos();     //获取宠物繁育信息列表
            }else if(data.reload) {       //浏览器重新刷新时执行的操作
                
            }
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {

               var ids=this.GetSelectDataIds();
               if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的宠物',type:'warning'});return false;}
               if(index==1) { //批量删除宠物
                   this.DelBirthInfos(ids.join(',')); 

               }else if(index==2) { //批量修改宠物类型
                   this.GoEditBirth(ids.join(','));
               }

            }).catch(()=> {
                
            });
        },


        /** 编辑提醒信息 **/
        EditBirth(id) {
            this.GoEditBirth(id);
        },


        /** 删除提醒 **/
        DelBirth(id) {
            this.DelBirthInfos(id);
        },


        /** 标记完成提醒 **/
        FinishBirth(id) {
            INTERFACE_MODEL_BIRTH.FINISH_BIRTH({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetBirthInfos();
            });
        },


        //删除繁育信息
        DelBirthInfos(ids) {
            INTERFACE_MODEL_BIRTH.DEL_BIRTH({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetBirthInfos();
            });
        },


        ///////////////////////////////////////
        ///////////////////////////////////////
        //加载宠物信息列表

         /** 获取宠物类型 **/
        GetPetTypelist() {
            INTERFACE_MODEL_PETS.GET_PET_Types({}).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
            });
        },


        /** 获取宠物信息列表 **/
        GetBirthInfos() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-birth-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_BIRTH.GET_BIRTH_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 this.$forceUpdate(); //强制渲染页面
            });
        },

        /** 修改当前页数 **/
        changepage(p) {
            this.param.p=p;
            this.GetBirthInfos();
        },

        changesize(rollpage) {
            this.param.rollpage=rollpage;
        },

        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.list);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


         /** 添加宠物信息 **/
        AddBirth() {
            var navinfo={name:'新增繁育',labelentry:'AddBirth',components:'AddBirth',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑繁育信息 **/
        GoEditBirth(ids) {
            var navinfo={name:'编辑繁育',labelentry:'EditBirth',components:'EditBirth',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('Birth',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },


        //加载宠物信息列表
        ///////////////////////////////////////
        ///////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-pet-infos {display: flex;align-items: center;}
.TTL-pet-infos-content {display:inline-block;width:calc(100% - 80px);margin-left:20px;}
.TTL-pet-infos-content-info {display: inline-flex;align-items: center;width:100%;}
.TTL-pet-infos-content-item {display:inline-block;color:#666666;background-color: #DCDFE6;padding:7px 15px 5px 15px;font-size:12px;line-height:12px;border-radius: 20px;margin:0 10px 5px 0;zoom:.9;}
.TTL-image-box-small {border-radius: 6px;}
.TTL-birth-box {display:inline-flex;align-items:center;}
.TTL-birth-info {display:inline-block;width:60px;text-align: center;position:relative;}
.manorwoman {position:absolute;top:0;right:0;width:22px;height:22px;padding:5px;background-color: #666eeb;border-radius: 50%;} 
.TTL-birth-name {font-size:12px;display:inline-block;width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.compare {display:inline-block;width:22px;height: 22px;margin:-20px 20px 0 20px;}
.TTL-birth-btd i {font-style: normal;color:#cf0f45;font-size:12px;font-weight: 600;}
.TTL-info-status-image {width:23px;height:23px;margin-left:5px;display:inline-flex;justify-content: center;align-items: center;}
.TTL-info-status-image .el-image {display:inline-flex;justify-content: center;align-items: center;width:100%;height:100%;}
.TTL-info-status-image .el-image img {width:100%;height: 100%;}

.TTL-BIRTH-LIST {display:inline-flex;width: 100%;align-items: center;}
.TTL-BIRTH-INFO {display:inline-block;padding:0 10px;width:200px;overflow: hidden;}
.TTL-BIRTH-COMPARE {display:inline-block;width:50px;text-align: center;font-size:14px;color:#666666;margin-top:-35px;}
.TTL-BIRTH-PETNAME {display:inline-block;width:100%;text-align: center;font-size:12px;color:#666666;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.TTL-btn-list {display:inline-flex;}
.brthname {color:#666eeb}
</style>